export default __webpack_public_path__ + "1f3985956853a0bf8c84c9ed94fa9301.png";